import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Submit The Listing Address',
    desc: 'Fill out a quick form or text us the property details.'
  }, {
    num: '02',
    title: 'Get A Same Day Quote',
    desc: 'Flat rate pricing sent within hours, no haggling.'
  }, {
    num: '03',
    title: 'We Handle Everything',
    desc: 'Crew dispatched, work completed, photos ready.'
  }, {
    num: '04',
    title: 'Close The Deal',
    desc: 'Listing goes live looking its absolute best.'
  }];
  return <section id="how-it-works" className="bg-apex-light py-20 md:py-28" data-id="element-129">
      <div className="container mx-auto px-4 md:px-6" data-id="element-130">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-131">
          <span className="text-apex-green font-bold text-sm uppercase tracking-[0.2em] block mb-4" data-id="element-132">
            Our Process
          </span>
          <h2 className="text-apex-charcoal font-extrabold text-3xl md:text-5xl tracking-tight" data-id="element-133">
            Four Steps. Zero Hassle.
          </h2>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:block relative" data-id="element-134">
          {/* Connecting Line */}
          <div className="absolute top-8 left-[10%] right-[10%] h-0.5 bg-gray-200" data-id="element-135" />

          <div className="grid grid-cols-4 gap-8 relative z-10" data-id="element-136">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-137">
                <div className="w-16 h-16 bg-white border-4 border-apex-light shadow-sm rounded-full flex items-center justify-center text-apex-green font-extrabold text-xl mb-6 relative" data-id="element-138">
                  {step.num}
                  {/* Subtle active dot */}
                  <div className="absolute -bottom-1.5 w-3 h-3 bg-apex-green rounded-full shadow-sm" data-id="element-139" />
                </div>
                <h3 className="text-lg font-bold text-apex-charcoal mb-2" data-id="element-140">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-141">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden relative pl-6" data-id="element-142">
          {/* Vertical Line */}
          <div className="absolute top-4 bottom-4 left-10 w-0.5 bg-gray-200" data-id="element-143" />

          <div className="flex flex-col gap-10 relative z-10" data-id="element-144">
            {steps.map((step, index) => <div key={index} className="flex gap-6 items-start" data-id="element-145">
                <div className="w-10 h-10 shrink-0 bg-white shadow-sm rounded-full flex items-center justify-center text-apex-green font-extrabold text-sm relative z-10" data-id="element-146">
                  {step.num}
                </div>
                <div className="pt-1.5" data-id="element-147">
                  <h3 className="text-lg font-bold text-apex-charcoal mb-1" data-id="element-148">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-149">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}